import { GridInitialStatePremium } from '@mui/x-data-grid-premium/models/gridStatePremium';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from 'routing';
import { useTitle } from 'shared/hooks';
import { ProvideTableData, createTableDataContext } from 'shared/providers/provideTableData';
import { ApprovalDashboardData } from 'types/backend';
import { Approvals } from './approvals';
import { TierOverrideApprovalResolver } from './tierOverrideApprovalResolver';

export const approvalsContext = createTableDataContext<ApprovalDashboardData>();
export const defaultApprovalsConfig: { initialState?: GridInitialStatePremium } | undefined = {
    initialState: {
        sorting: {
            sortModel: [
                {
                    field: 'status',
                    sort: 'desc',
                },
                {
                    field: 'dateRequested',
                    sort: 'desc',
                },
            ],
        },
        pagination: {
            paginationModel: {
                page: 0,
                pageSize: 100,
            },
        }
    },
};

export default function ApprovalsResolver() {
    useTitle(`Approval Dashboard - Paragon`);

    return (
        <ProvideTableData name='ApprovalDashboard' tableDataContext={approvalsContext} config={defaultApprovalsConfig}>
            <Switch>
                <Route exact path={ROUTES.approvals}>
                    <Approvals />
                </Route>
                <Route path={ROUTES.tierOverrideApprovals}>
                    <TierOverrideApprovalResolver />
                </Route>
            </Switch>
        </ProvideTableData>
    );
}
